const API_URL = process.env.NEXT_PUBLIC_WORDPRESS_API_URL as string;

export async function fetchWP(query = "") {
  const headers: Record<string, any> = { "Content-Type": "application/json" };

  try {
    const res = await fetch(API_URL, {
      headers,
      method: "POST",
      body: JSON.stringify({ query }),
      next: { revalidate: 180 },
    });

    if (!res.ok) {
      throw new Error(`Network response was not ok (${res.status})`);
    }

    const json = await res.json();
    return json.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    // Handle the error as needed in your application
    throw error; // Rethrow or handle as necessary for your application logic
  }
}
